export const THEMES = ['violet', 'light', 'green', 'dark', 'magenta'] as const;

export type Theme = (typeof THEMES)[number];
